export function dateFormat(value): string {
  if (value) {
    let date = value instanceof Date ? value : new Date(value);
    let dateString = `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}/${
      date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    }/${date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear()} `;
    let hour = `${date.getHours() < 10 ? '0' + date.getHours() : date.getHours()}:${
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    } hs`;

    return (
      '<div class="text-label" style="font-weight: bold;">' +
      dateString.toString() +
      '</div><div>' +
      hour.toString() +
      '</div>'
    );
  }
}

export function dateFormatNotHour(value): string {
  if (value) {
    let date = value instanceof Date ? value : new Date(value);
    return `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}/${
      date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    }/${date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear()}`;
  }
}

export function notHourDateFormat(value: string | Date): string {
  if (value) {
    const date = new Date(value);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
